import classNames from '@/utils/classNames';
import type { HTMLAttributes } from 'react';
import type { FCC } from 'react-fc';
import styles from './IndicatorBadge.module.css';

/**
 * A notification indicator for text or numbers.
 */
export const IndicatorBadge: FCC<HTMLAttributes<HTMLSpanElement>> = ({ className, children, ...rest }) => (
    <span {...rest} className={classNames(styles.indicatorBadge, className)}>
        {children}
    </span>
);
